import DeliveryAddressList from 'client/delivery_address/DeliveryAddressList'
import { IClient } from 'client/IClientInfo'
import ToggledInput from 'components/ToggledInput'
import WithGrayLabel from 'components/WithGrayLabel'
import React, { useCallback, useEffect, useState } from 'react'
import { formatPhoneNumber } from 'utils'
import { reqGetClientInfo, reqUpdateClientParam } from '../client/ClientRequests'

interface IClientInfoFormProps {
  clientInfo: IClient
  onChange: (client: IClient) => void
}

const ClientInfoForm: React.FC<IClientInfoFormProps> = ({ clientInfo, onChange }) => {
  // const [clientInfo, setClientInfo] = useState<IClient>(clientInfoProp)
  const [disableChange, setDisableChange] = useState<boolean>(!clientInfo.freedom_login)

  useEffect(() => {
    setDisableChange(!!clientInfo.freedom_login)
  }, [clientInfo])

  const handleChangeInfo = useCallback(
    (paramKey, value) => {
      console.log('req', paramKey, value)
      reqUpdateClientParam(paramKey, value, () => {
        reqGetClientInfo((info: IClient) => onChange(info))
      })
    },
    [onChange]
  )

  return (
    <div>
      <WithGrayLabel label='Номер телефона' absecePlaceholder='Не указано'>
        <div className=''>
          {clientInfo.phone_number
            ? formatPhoneNumber(clientInfo.phone_number)
            : 'Не указано'}
        </div>
      </WithGrayLabel>

      {/* <WithGrayLabel label='Учетное имя(логин)' absecePlaceholder='Не указано'> */}
      {/* {clientInfo.login} */}
      {/* </WithGrayLabel> */}

      <WithGrayLabel label='Ваше имя' absecePlaceholder='Не указано'>
        <ToggledInput
          input={{
            id: 'name',
            type: 'str',
            title: 'Ваше имя',
            defaultValue: clientInfo.name,
            required: true,
            otherProps: { maxLength: 50, style: { maxWidth: '200px' } },
          }}
          onConfirm={handleChangeInfo}
          disable={disableChange}
        />
      </WithGrayLabel>

      <WithGrayLabel label='Почта' absecePlaceholder='Не указано'>
        <ToggledInput
          input={{
            id: 'email',
            type: 'email',
            title: 'Почта',
            defaultValue: clientInfo.email,
            required: false,
            otherProps: { maxLength: 100, style: { maxWidth: '200px' } },
          }}
          onConfirm={handleChangeInfo}
          disable={disableChange}
        />
      </WithGrayLabel>

      <h5 className='mt-3'>Используемые адреса доставки</h5>
      <DeliveryAddressList />

      {/* <WithGrayLabel label='Улица' absecePlaceholder='Не указано'>
        <ToggledInput
          input={{
            id: 'street_name',
            type: 'str',
            title: 'Улица',
            defaultValue: clientInfo.addresses[0].street,
            required: true,
            otherProps: { maxLength: 50, style: { maxWidth: '200px' } },
          }}
          onConfirm={handleChangeInfo}
          disable={disableChange}
        />
      </WithGrayLabel>
      <WithGrayLabel label='Дом' absecePlaceholder='Не указано'>
        <ToggledInput
          input={{
            id: 'building_number',
            type: 'str',
            title: 'Дом',
            defaultValue: clientInfo.addresses[0].building,
            required: true,
            otherProps: { maxLength: 10, style: { maxWidth: '200px' } },
          }}
          onConfirm={handleChangeInfo}
          disable={disableChange}
        />
      </WithGrayLabel>
      <WithGrayLabel label='Квартира' absecePlaceholder='Не указано'>
        <ToggledInput
          input={{
            id: 'flat',
            type: 'int',
            title: 'Квартира',
            defaultValue: clientInfo.addresses[0].flat,
            required: true,
            otherProps: { style: { maxWidth: '200px' } },
          }}
          onConfirm={handleChangeInfo}
          disable={disableChange}
        />
      </WithGrayLabel>
      <WithGrayLabel label='Подъезд' absecePlaceholder='Не указано'>
        <ToggledInput
          input={{
            id: 'entrance',
            type: 'int',
            title: 'Подъезд',
            defaultValue: clientInfo.addresses[0].entrance,
            required: true,
            otherProps: { maxLength: 50, style: { maxWidth: '200px' } },
          }}
          onConfirm={handleChangeInfo}
          disable={disableChange}
        />
      </WithGrayLabel>
      <WithGrayLabel label='Этаж' absecePlaceholder='Не указано'>
        <ToggledInput
          input={{
            id: 'floor',
            type: 'int',
            title: 'Этаж',
            defaultValue: clientInfo.addresses[0].floor,
            required: true,
            otherProps: { style: { maxWidth: '200px' } },
          }}
          onConfirm={handleChangeInfo}
          disable={disableChange}
        />
      </WithGrayLabel> */}
    </div>
  )
}
export default ClientInfoForm
